/**
 * @generated SignedSource<<28c3ca9937bc43cc0f38862d4e7e43fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserEventFiltersInput = {
  filterKeywords?: ReadonlyArray<string | null> | null;
  includeAllDay?: boolean | null;
  includeCancelled?: boolean | null;
  includeDeclined?: boolean | null;
  includeFocusTime?: boolean | null;
  includeHidden?: boolean | null;
  includeOutOfOffice?: boolean | null;
  includePersonalMeetings?: boolean | null;
};
export type EventFiltersUpdateMutation$variables = {
  filters: UserEventFiltersInput;
};
export type EventFiltersUpdateMutation$data = {
  readonly updateEventFilters: {
    readonly eventFilters: {
      readonly filterKeywords: ReadonlyArray<string | null>;
      readonly includeAllDay: boolean;
      readonly includeCancelled: boolean;
      readonly includeDeclined: boolean;
      readonly includeFocusTime: boolean;
      readonly includeHidden: boolean;
      readonly includeOutOfOffice: boolean;
      readonly includePersonalMeetings: boolean;
    } | null;
  } | null;
};
export type EventFiltersUpdateMutation = {
  response: EventFiltersUpdateMutation$data;
  variables: EventFiltersUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeCancelled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeHidden",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeDeclined",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeAllDay",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeOutOfOffice",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeFocusTime",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includePersonalMeetings",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterKeywords",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventFiltersUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateEventFilters",
        "kind": "LinkedField",
        "name": "updateEventFilters",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEventFiltersNode",
            "kind": "LinkedField",
            "name": "eventFilters",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventFiltersUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateEventFilters",
        "kind": "LinkedField",
        "name": "updateEventFilters",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEventFiltersNode",
            "kind": "LinkedField",
            "name": "eventFilters",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "86a31f1d047faa02617300f3ec1de2dc",
    "id": null,
    "metadata": {},
    "name": "EventFiltersUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation EventFiltersUpdateMutation(\n  $filters: UserEventFiltersInput!\n) {\n  updateEventFilters(filters: $filters) {\n    eventFilters {\n      includeCancelled\n      includeHidden\n      includeDeclined\n      includeAllDay\n      includeOutOfOffice\n      includeFocusTime\n      includePersonalMeetings\n      filterKeywords\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a95f2a6c1ad4c74c86fbf9b9e705cf0";

export default node;
